// This file was autogenerated with oarepo-tools
import TRANSLATE_EN from "./en/LC_MESSAGES/translations.json";
import TRANSLATE_CS from "./cs/LC_MESSAGES/translations.json";

export const translations = {
  en: { translation: TRANSLATE_EN },
  cs: { translation: TRANSLATE_CS },
};
